export default {"src":"/_next/static/media/peopleGroup.423cc457.svg","height":70,"width":51};